/**
 * Field bandage. The one thing that answers a bleeding wound, and the reason a consumable stacks:
 * carrying one is a decision, carrying ten is a loadout.
 */

import type { ConsumableItem } from '@/sim/items/itemContract';

export const FIELD_BANDAGE = {
  id: 'fieldBandage',
  kind: 'consumable',
  label: 'Field bandage',
  description: 'Sterile in 1961. Wrap firmly and continue with your duties.',
  rarity: 'common',
  weightKg: 0.15,
  stackLimit: 10,
  equip: null,
  healAmount: 25,
  clears: ['bleeding'],
  useTicks: 180,
} as const satisfies ConsumableItem;
